import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getAppStartTime } from 'flow/selectors/selectors';
var IntervalRenderer = /*#__PURE__*/function (_React$Component) {
  function IntervalRenderer() {
    _classCallCheck(this, IntervalRenderer);
    return _callSuper(this, IntervalRenderer, arguments);
  }
  _inherits(IntervalRenderer, _React$Component);
  return _createClass(IntervalRenderer, [{
    key: "start",
    value: function start() {
      var _this = this;
      var _this$props = this.props,
        appStartTime = _this$props.appStartTime,
        interval = _this$props.interval;
      var diff = Date.now() - appStartTime;
      var remainder = diff % interval;
      this.intervalId = window.setInterval(function () {
        clearInterval(_this.intervalId);
        _this.intervalId = window.setInterval(function () {
          _this.forceUpdate();
        }, interval);
      }, remainder);
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = 0;
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.start();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children();
    }
  }]);
}(React.Component);
_defineProperty(IntervalRenderer, "propTypes", {
  interval: PropTypes.number.isRequired,
  appStartTime: PropTypes.number.isRequired,
  children: PropTypes.func.isRequired
});
var mapStateToProps = function mapStateToProps(state) {
  return {
    appStartTime: getAppStartTime(state)
  };
};
export default connect(mapStateToProps)(IntervalRenderer);